import { render, staticRenderFns } from "./ModifyDepartment.vue?vue&type=template&id=32a81dbe&scoped=true&"
import script from "./ModifyDepartment.vue?vue&type=script&lang=js&"
export * from "./ModifyDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ModifyDepartment.vue?vue&type=style&index=0&id=32a81dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a81dbe",
  null
  
)

export default component.exports